import { useEffect, useMemo, useState } from 'react';
import type { BodyIssueRecord, BodyRegionKey } from '../types/bodyMapIssue';
import { listBodyIssues } from '../services/bodyMapIssueService';

export default function useBodyMapIssues(userId?: string) {
  const [loading, setLoading] = useState(true);
  const [issues, setIssues] = useState<BodyIssueRecord[]>([]);
  const [selectedRegionKey, setSelectedRegionKey] = useState<BodyRegionKey | null>(null);

  useEffect(() => {
    const load = async () => {
      if (!userId) {
        setIssues([]);
        setLoading(false);
        return;
      }

      try {
        const loaded = await listBodyIssues(userId);
        setIssues(loaded);
      } finally {
        setLoading(false);
      }
    };

    load();
  }, [userId]);

  const selectedRegionIssues = useMemo(
    () => (selectedRegionKey ? issues.filter((issue) => issue.regionKey === selectedRegionKey) : issues),
    [issues, selectedRegionKey],
  );

  return {
    loading,
    issues,
    selectedRegionKey,
    setSelectedRegionKey,
    selectedRegionIssues,
    refresh: async () => {
      if (!userId) return;
      setLoading(true);
      try {
        setIssues(await listBodyIssues(userId));
      } finally {
        setLoading(false);
      }
    },
  };
}
